import axios from 'config/api';
import { FETCH_RECORD_SUCCESS } from 'config/constants';

export function fetchUsersRecords() {
  return axios
    .get('/user/templates-records')
    .then(({ data, status }) => {
      if (status === 200) {
        return {
          type: FETCH_RECORD_SUCCESS,
          records: data,
        };
      }

      throw new Error();
    })
    .catch(error => {
      console.error('Por favor, entre em contato com o suporte.', error);
      throw error;
    });
}
